import { useState, useCallback } from 'react';
import { adminApi } from '../utils/api';

export function useAuth() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('adeona_user')); }
    catch { return null; }
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const login = useCallback(async (email, password) => {
    setLoading(true); setError('');
    try {
      const { data } = await adminApi.login({ email, password });
      localStorage.setItem('adeona_token', data.token);
      localStorage.setItem('adeona_user', JSON.stringify(data.user));
      setUser(data.user);
      return true;
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check your credentials.');
      return false;
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('adeona_token');
    localStorage.removeItem('adeona_user');
    setUser(null);
  }, []);

  return { user, loading, error, login, logout, isLoggedIn: !!user };
}
